var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "crud" },
    [
      _vm._l(_vm.uploadedFiles, function (item) {
        return [
          _c("div", { key: item.id, staticClass: "receitasLista" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.editaDateInclusao(item.dataInclusao)) +
                " -\n            "
            ),
            _c("strong", [
              _vm._v("[" + _vm._s(_vm.getDescricaoPorTipo(item.tipo)) + "]"),
            ]),
            _vm._v(
              "\n            " + _vm._s(item.descricao) + "\n            "
            ),
            _vm.mostrarVinculoManipulacoes &&
            item.manipulacoesVinculadas &&
            item.manipulacoesVinculadas.length > 0
              ? _c(
                  "a",
                  {
                    staticClass: "receitaManipulacoesResumo",
                    on: {
                      click: function ($event) {
                        _vm.toggleExpandManipulacoes(item)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                - " +
                        _vm._s(
                          _vm.$t(
                            "__.Components.parent.venda.uploadReceita_vue_html.manipulacoesVinculadas"
                          )
                        ) +
                        ":\n                "
                    ),
                    _c(
                      "span",
                      { staticClass: "receitaManipulacoesResumoTexto" },
                      [_vm._v(_vm._s(_vm.manipulacoesResumoTexto(item)))]
                    ),
                    _vm._v(" "),
                    _vm.manipulacoesRestantesCount(item) > 0
                      ? _c(
                          "span",
                          { staticClass: "receitaManipulacoesResumoMais" },
                          [
                            _vm._v(
                              "\n                    +" +
                                _vm._s(_vm.manipulacoesRestantesCount(item)) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      class: [
                        "fa",
                        _vm.isExpandedManipulacoes(item)
                          ? "fa-chevron-up"
                          : "fa-chevron-down",
                      ],
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            item.id
              ? _c(
                  "a",
                  {
                    staticClass: "btnAcaoUp1",
                    on: {
                      click: function ($event) {
                        _vm.onView(item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-eye" })]
                )
              : _vm._e(),
            _vm._v(" "),
            item.id
              ? _c(
                  "a",
                  {
                    staticClass: "btnAcaoUp2",
                    on: {
                      click: function ($event) {
                        _vm.onDownload(item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-download" })]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.somenteConsultaVenda
              ? _c(
                  "a",
                  {
                    staticClass: "btnAcaoUp3",
                    on: {
                      click: function ($event) {
                        _vm.onDelete(item)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.mostrarVinculoManipulacoes &&
          _vm.isExpandedManipulacoes(item) &&
          item.manipulacoesVinculadas.length > 0
            ? _c(
                "div",
                {
                  key: "detalhe-" + item.id,
                  staticClass: "receitaManipulacoesDetalhe",
                },
                [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "__.Components.parent.venda.uploadReceita_vue_html.codigo"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "__.Components.parent.venda.uploadReceita_vue_html.formaFarmaceutica"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        item.manipulacoesVinculadas,
                        function (manipulacao) {
                          return _c("tr", { key: manipulacao.id }, [
                            _c("td", [_vm._v(_vm._s(manipulacao.codigo))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(manipulacao.formaFarmaceuticaDescricao)
                              ),
                            ]),
                          ])
                        }
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      !_vm.somenteConsultaVenda
        ? _c("div", { staticStyle: { "margin-top": "15px" } }, [
            _c("div", { staticClass: "row" }, [
              _vm.isSingleFileMode
                ? _c(
                    "div",
                    { class: _vm.colClassUploadReceita },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "tipo" },
                        },
                        [
                          _c("span", { staticClass: "color-red" }, [
                            _vm._v("*"),
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.tipoAnexo"
                                )
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("combo-component", {
                        attrs: {
                          id: "tipo",
                          name: "tipo",
                          data: _vm.tipoReceitaArquivoOptions,
                          searchable: false,
                        },
                        on: { input: _vm.onChangeTipo },
                        model: {
                          value: _vm.model.tipo,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "tipo", $$v)
                          },
                          expression: "model.tipo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isSingleFileMode
                ? _c("div", { class: _vm.colClassUploadReceita }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "descricao" },
                      },
                      [
                        _c("span", { staticClass: "color-red" }, [_vm._v("*")]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t(
                                "__.Components.parent.venda.uploadReceita_vue_html.nomeArquivo"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.descricao,
                          expression: "model.descricao",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|max:256",
                          expression: "'required|max:256'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "descricao",
                        name: "descricao",
                        autocomplete: "off",
                      },
                      domProps: { value: _vm.model.descricao },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "descricao", $event.target.value)
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showVinculoManipulacao
                ? _c(
                    "div",
                    { class: _vm.colClassUploadReceita },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "manipulacoesSelecionadas" },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.manipulacoesVinculadas"
                                )
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showMultiSelectManipulacao
                        ? _c("multiSelect-component", {
                            attrs: {
                              id: "manipulacoesSelecionadas",
                              name: "manipulacoesSelecionadas",
                              defaultValue: _vm.manipulacoesSelecionadas,
                              options: _vm.manipulacoesOptions,
                            },
                            model: {
                              value: _vm.manipulacoesSelecionadas,
                              callback: function ($$v) {
                                _vm.manipulacoesSelecionadas = $$v
                              },
                              expression: "manipulacoesSelecionadas",
                            },
                          })
                        : _c("div", { staticClass: "form-control-static" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Components.parent.venda.uploadReceita_vue_html.salveOrcamentoVincular"
                                  )
                                ) +
                                "\n                "
                            ),
                          ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.colClassUploadReceita },
                [
                  _c("p"),
                  _vm._v(" "),
                  _c("file-picker-component", {
                    ref: "filePicker",
                    attrs: { id: "file", name: "file", multiple: true },
                    on: { "files-selected": _vm.onFilesSelected },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.selectedFilesWithNames.length > 1
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _vm.isEstereis
                      ? _c("div", { staticClass: "alert alert-warning" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.vinculoUmArquivoPorVez"
                                )
                              ) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: {
                          "margin-bottom": "5px",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _c("div", { staticClass: "col-sm-3" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.tipoAnexo"
                                )
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.nomeArquivo"
                                )
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-5" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.arquivoSelecionado"
                                )
                              ) +
                              "\n                "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.selectedFilesWithNames, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "row",
                          staticStyle: { "margin-bottom": "10px" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-sm-3" },
                            [
                              _c("combo-component", {
                                attrs: {
                                  id: "tipo-" + index,
                                  name: "tipo-" + index,
                                  data: _vm.tipoReceitaArquivoOptions,
                                  searchable: false,
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.onChangeMultipleTipo(item)
                                  },
                                },
                                model: {
                                  value: item.model.tipo,
                                  callback: function ($$v) {
                                    _vm.$set(item.model, "tipo", $$v)
                                  },
                                  expression: "item.model.tipo",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-4" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.model.descricao,
                                  expression: "item.model.descricao",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t(
                                  "__.Components.parent.venda.uploadReceita_vue_html.digiteNomeArquivo"
                                ),
                              },
                              domProps: { value: item.model.descricao },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.model,
                                    "descricao",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-5",
                              staticStyle: { "padding-top": "8px" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.file.name) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row",
                        staticStyle: { "margin-top": "15px" },
                      },
                      [
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              attrs: { type: "button" },
                              on: { click: _vm.salvarArquivos },
                            },
                            [
                              _vm.vendaId
                                ? _c("i", { staticClass: "fa fa-save" })
                                : _vm._e(),
                              _vm._v(
                                "\n\n                        " +
                                  _vm._s(
                                    _vm.vendaId
                                      ? _vm.$t(
                                          "__.Components.parent.venda.uploadReceita_vue_html.salvarArquivos"
                                        )
                                      : _vm.$t(
                                          "__.Components.parent.venda.uploadReceita_vue_html.adicionarArquivos"
                                        )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }